import React, { useState } from "react";
import { examDuration } from "../constant/Constants";

const SchoolAccordionPage = () => {
  const [active, setActive] = useState(1);
  const handleActive = (index) => {
    setActive((prev) => (prev === index ? 0 : index));
  };

  const faqDataFull = [
    {
      id: "One",
      ariaExpanded: "true",
      title: "Can Practido help students prepare for multiple Olympiads?",
      content: `Absolutely. Practido is built for exactly that. Whether it’s the IMO Olympiad, Science Olympiad, or other competitive assessments, our digital <b>test papers</b>, AI-proctored exams, and real-time performance insights ensure students get structured, competition-ready practice. With unlimited practice tests, personalized analytics, and <u>STEM learning</u>–aligned challenges, students can <u>learn and study</u> smarter for multiple Olympiads at once.`,
    },
    {
      id: "Two",
      ariaExpanded: "false",
      title: `How does Practido help students prepare for the IMO Olympiad and other competitions?`,
      content:
        "Preparing for the <u>IMO Olympiad</u> becomes far more efficient on Practido. Students get access to secure online exams, targeted practice tests, instant grading, global rankings, and detailed performance breakdowns. The platform continuously tracks strengths and weaknesses, helping students sharpen their math skills and build exam stamina. From mock <b>test papers</b> to real-time insights, Practido turns competitive prep into a seamless <u>teaching and learning</u> experience.",
    },
    {
      id: "Three",
      ariaExpanded: "false",
      title: "What type of test papers are available for students?",
      content:
        "Practido offers every kind of test paper a modern learner needs, from school-level assessments to advanced competitive exam mocks. Students can access practice papers for math, science, English, reasoning, and Olympiads like IMO. With automated grading, interactive question formats, AI-proctored sessions, and unlimited practice options, every test paper feels smart, adaptive, and perfectly aligned with how students learn and study today.",
    },
    {
      id: "Four",
      ariaExpanded: "false",
      title: "How can teachers track student progress?",
      content:
        "Teachers get a powerful real-time dashboard that makes progress tracking effortless. They can monitor performance trends, class-wise results, international standings, learning gaps, and student activity in seconds. Detailed reports break down each test paper attempt, helping teachers intervene early and personalize their <u>teaching and learning</u> strategies for better academic outcomes.",
    },
    {
      id: "Five",
      ariaExpanded: "false",
      title: "How can our school start using Practido?",
      content:
        "Getting started is surprisingly simple. Schools can onboard their teachers and students into Practido’s digital ecosystem, set up test papers, and begin conducting online exams right away. In short: plug it in, set it up, and transform the way your students <u>learn and study</u> from day one.",
    }
    
  ];
  return (
    <div className="accordion" id="accordiondata">
      {faqDataFull?.map(({ id, ariaExpanded, title, content }, index) => (
        <div
          className={`card ${active === index + 1 ? "active" : ""}`}
          key={id}
        >
          <div className="card-header" id={`heading${id}`}>
            <button
              className={`btn-link btn-block text-left ${
                ariaExpanded !== "true" ? "collapsed" : ""
              }`}
              type="button"
              data-toggle="collapse"
              data-target={`#collapse${id}`}
              aria-expanded={ariaExpanded}
              aria-controls={`collapse${id}`}
              onClick={() => handleActive(index + 1)}
             
            >
              {title}
            </button>
          </div>
          <div
            id={`collapse${id}`}
            className={`collapse ${ariaExpanded === "true" ? "show" : ""}`}
            aria-labelledby={`heading${id}`}
            data-parent="#accordiondata"
          >
            <div
              className="card-body"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SchoolAccordionPage;
